module.exports = __webpack_public_path__ + "img/44.d6006df.png";